import React from 'react';

const TransactionsPage: React.FC = () => (
  <div>
    <h1>Transactions Page</h1>
    <p>Coming soon...</p>
  </div>
);

export default TransactionsPage;
